/**
 * Renders empty state in SearchWindow component
 */
export function EmptyState() {
    return (
        <div className="border-t border-slate-100 px-6 py-14 text-center sm:px-14">
            <p className="mt-4 text-base font-semibold text-slate-900">
                No results found
            </p>
            <p className="mt-2 text-base text-slate-500">
                We can’t find anything with that term at the moment, try
                searching something else.
            </p>
        </div>
    );
}
